import ReferrerColumn from './ReferrerColumn';

export default ReferrerColumn;
